var React = require('react');

function Code (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"anooprav7"),React.createElement("polyline",{"points":"160 368 32 256 160 144","style":{"fill":"none","stroke":"#FFC107","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32px"},"key":1}),React.createElement("polyline",{"points":"352 368 480 256 352 144","style":{"fill":"none","stroke":"#FFC107","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32px"},"key":2}),React.createElement("line",{"x1":"304","y1":"96","x2":"208","y2":"416","style":{"fill":"none","stroke":"#FFC107","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32px"},"key":3})]);
}

Code.defaultProps = {"width":"512","height":"512","viewBox":"0 0 512 512"};

module.exports = Code;

Code.default = Code;
